import styled from "styled-components";
import React, { RefObject, useEffect, useState } from 'react';
import { P } from "@src/components/atoms";
import { ThemeType } from "@src/types/theme";
import LibraryService from "@src/services/library/LibraryService";
import { t_library } from "@src/types/tables";
import { cvtJson2Library } from "@src/lib/public-lib";
import { getCookie } from "@src/lib/util/cookie";
import ListItem from "@src/components/common/list/ListItem";
import UserService from "@src/services/user/UserService";
import CartService from "@src/services/cart/CartService";
import { useSelector } from "react-redux";
import { RootState } from "@src/store";
import { useTranslation } from "next-i18next";

export type DetailOthersProps = {
    height: number;
    libraries: t_library[];
    handleItemPlay: any;
    handleItemPause: any;
    play: boolean;
    playId: string;
    setPlayId: any;
    listArrayRef: RefObject<HTMLDivElement>[];
};

export default function DetailOthers(props: DetailOthersProps)
{
    const { t } = useTranslation("common");
    const user = useSelector((state: RootState) => state.user);
    
    const [ listData, setListData ] = useState<t_library[]>([]);
    const [ lastPlayer, setLastPlayer ] = useState<HTMLAudioElement>();
    const [ buyList, setBuyList ] = useState<any[]>([]);
	const [ cartList, setCartList ] = useState<any[]>([]);
    const [ stateChange, setStateChange ] = useState<"" | "add" | "remove">("");

    useEffect(() => {
        UserService.buyList({ userId: user.id })
		.then(res => setBuyList(res));

		CartService.cartLibraries({ userId: user.id })
		.then(res => setCartList(res));
    }, []);

    useEffect(() => {
		if (stateChange !== "")
		{
			CartService.cartLibraries({ userId: user.id })
			.then(res => setCartList(res));

			setStateChange("");
		}
	}, [stateChange]);

    return(
        <Wrapper style={{ marginTop: `${props.height + 32}px` }}>
            { props.libraries.length > 0 &&
                <>
                    <Text>{ "유사한 음악" }</Text>
                    { props.libraries.map((data: t_library, index: number) =>
                        <ListItem
                            data={ data }
                            index={ index }
                            key={ "detail" + index }
                            isPurchase={ buyList.some(e => e.LIBRARY_USE_ID === data.id) }
                            isInCart={ cartList.some(e => e.LIBRARY_ID === data.id) }
                            setStateChange={ setStateChange }
                            handleItemPlay={ props.handleItemPlay }
                            handleItemPause={ props.handleItemPause }
                            play={ props.play }
                            playId={ props.playId }
                            setPlayId={ props.setPlayId }
                            divRef={ props.listArrayRef[index] }
                            listType={ "library" }
                        />
                    )}
                </>
            }
        </Wrapper>
    );
}

const Wrapper = styled.div`
    height: fit-content;
    //margin-top: 32px;

    ${({ theme }: { theme: ThemeType }) => theme.mobile`
        width: 100%;
        margin-left: 0;
	`};
`;

const Text = styled(P)`
    color: #FFF;
    font-family: Pretendard;
    font-size: 0.32rem;
    font-weight: 700;
    line-height: 1.5; 
    
    ${({ theme }: { theme: ThemeType }) => theme.largeTablet`
        width: 100%;
        text-align: center;    
        font-size: 0.2rem
	`};
`;

const Square = styled.div`
    min-width: 30%;
    padding-bottom: 30%;
    background-color: ${props => props.color};
    margin: 1.5% 1.5%;
    flex: auto;

    P {
        color: white;
        position: absolute;
    }
`;